import { WorkspaceSettingsPageType } from '@baserow/modules/core/workspaceSettingsPageTypes'

/**
 * La pestana "Acceso a bases" en los ajustes del espacio de trabajo.
 *
 * Va al lado de Miembros e Invitaciones porque es la misma conversacion: quien
 * entra y que ve. La ruta la registra module.js con extendPages.
 *
 * Solo la ve quien puede administrar el espacio; el endpoint comprueba lo mismo
 * del lado del servidor, que es donde cuenta.
 */
export class AccesoABasesWorkspaceSettingsPageType extends WorkspaceSettingsPageType {
  static getType() {
    return 'acceso_bases_mg'
  }

  getName() {
    return 'Acceso a bases'
  }

  hasPermission(workspace) {
    return this.app.$hasPermission(
      'workspace.list_workspace_users',
      workspace,
      workspace.id
    )
  }

  getRoute(workspace) {
    return {
      name: 'settings-acceso-mg',
      params: { workspaceId: workspace.id },
    }
  }
}
